import { CallAdapter } from './callAdapter';

export class FreeswitchVoiceAdapter extends CallAdapter {
  constructor({ sendSignal, iceServers = [] }) {
    super();
    this.sendSignal = sendSignal;
    this.remoteStream = null;
    this.iceCandidatesQueue = [];
    this.iceServers = iceServers.length ? iceServers : [
      { urls: 'stun:stun.l.google.com:19302' },
      {
        urls: [
          'turn:20.46.147.126:3478?transport=udp',
          'turn:20.46.147.126:3478?transport=tcp',
          'stun:20.46.147.126:3478'
        ],
        username: 'webrtcuser',
        credential: 'webrtcpassword123'
      }
    ];
  }

  async connect({ isCaller, conversationId, sipCredentials }) {
    try {
      this.localStream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true
        }
      });

      this.peerConnection = new RTCPeerConnection({
        iceServers: this.iceServers
      });

      this.peerConnection.oniceconnectionstatechange = () => {
        console.log('FreeSWITCH WebRTC: ICE Connection State:', this.peerConnection?.iceConnectionState);
      };

      this.peerConnection.onconnectionstatechange = () => {
        console.log('FreeSWITCH WebRTC: Connection State:', this.peerConnection?.connectionState);
      };

      this.localStream.getTracks().forEach(track => {
        this.peerConnection.addTrack(track, this.localStream);
      });

      this.peerConnection.ontrack = event => {
        this.remoteStream = event.streams[0];
        this.dispatchEvent('track', this.remoteStream);
      };

      this.peerConnection.onicecandidate = event => {
        if (event.candidate && this.sendSignal) {
          this.sendSignal({
            conversation_id: conversationId,
            signal: { type: 'candidate', candidate: event.candidate }
          });
        }
      };

      if (isCaller) {
        const offer = await this.peerConnection.createOffer();
        await this.peerConnection.setLocalDescription(offer);
        if (this.sendSignal) {
          this.sendSignal({
            conversation_id: conversationId,
            signal: { type: 'offer', sdp: offer.sdp }
          });
        }
      }
    } catch (err) {
      console.error('FreeSWITCH WebRTC connect error:', err);
      this.disconnect();
      throw err;
    }
  }

  async handleSignal(signal) {
    if (!this.peerConnection) return;

    if (signal.type === 'offer') {
      await this.peerConnection.setRemoteDescription(new RTCSessionDescription(signal));
      const answer = await this.peerConnection.createAnswer();
      await this.peerConnection.setLocalDescription(answer);
      if (this.sendSignal) {
        this.sendSignal({
          signal: { type: 'answer', sdp: answer.sdp }
        });
      }
      await this.processQueuedCandidates();
    } else if (signal.type === 'answer') {
      await this.peerConnection.setRemoteDescription(new RTCSessionDescription(signal));
      await this.processQueuedCandidates();
    } else if (signal.type === 'candidate') {
      if (this.peerConnection.remoteDescription) {
        try {
          await this.peerConnection.addIceCandidate(new RTCIceCandidate(signal.candidate));
        } catch (e) {
          console.error('FreeSWITCH Error adding ice candidate:', e);
        }
      } else {
        this.iceCandidatesQueue.push(signal.candidate);
      }
    }
  }

  async processQueuedCandidates() {
    while (this.iceCandidatesQueue.length > 0) {
      const candidate = this.iceCandidatesQueue.shift();
      try {
        await this.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
      } catch (e) {
        console.error('FreeSWITCH Error adding queued ice candidate:', e);
      }
    }
  }

  async disconnect() {
    if (this.peerConnection) {
      this.peerConnection.close();
      this.peerConnection = null;
    }
    if (this.localStream) {
      this.localStream.getTracks().forEach(track => track.stop());
      this.localStream = null;
    }
    this.dispatchEvent('disconnected');
  }

  setMuted(shouldMute) {
    if (this.localStream) {
      this.localStream.getAudioTracks().forEach(track => {
        track.enabled = !shouldMute;
      });
    }
  }
}
